pageLoad('dashboards_show', () => {
  $('.bottom-items .skud-password').on('click', ({ currentTarget }) => {
    const $mask = $(currentTarget).find('.mask');
    const $value = $(currentTarget).find('.value');
    $mask.toggleClass('hidden');
    $value.toggleClass('hidden');
  });
});
